import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  text: string;
  confirmLabel: string;
  cancelLabel: string;
  tone?: 'danger' | 'primary';
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  text,
  confirmLabel,
  cancelLabel,
  tone = 'danger',
  loading = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={loading ? () => undefined : onClose}
      size="sm"
      footer={
        <>
          <Button variant="outline" size="md" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            variant={tone === 'danger' ? 'danger' : 'primary'}
            size="md"
            loading={loading}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex items-start gap-3">
        <span
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${
            tone === 'danger' ? 'bg-rose-50 text-rose-600' : 'bg-amber-50 text-amber-600'
          }`}
        >
          <i
            className={`${tone === 'danger' ? 'ri-delete-bin-6-line' : 'ri-eye-off-line'} text-xl leading-none`}
            aria-hidden="true"
          />
        </span>
        <div className="min-w-0">
          <h3 className="text-base font-semibold text-foreground-950">{title}</h3>
          <p className="mt-1 text-sm leading-relaxed text-foreground-600">{text}</p>
        </div>
      </div>
    </Modal>
  );
}